import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert, Button } from '@mui/material';

const InAppNotification = () => {
  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    // Verificar que el navegador soporte service workers
    if (!('serviceWorker' in navigator)) {
      console.log('Service Worker no es soportado en este navegador');
      return;
    }
    
    // Función para manejar mensajes del service worker
    const handlePushMessage = (event) => {
      console.log('Mensaje recibido del service worker:', event.data);
      
      // Si el mensaje es de tipo PUSH_RECEIVED, extraer los datos
      if (event.data?.type === 'PUSH_RECEIVED') {
        setNotification({
          title: event.data.title,
          message: event.data.body,
          url: event.data.data?.url || '/',
          severity: event.data.data?.severity || 'info'
        });
        return;
      }
      
      // Si el mensaje tiene un formato diferente, intentar extraer los datos relevantes
      let data = event.data;
      
      // Si es un objeto con campos notification o data, extraerlo
      if (data?.notification) {
        setNotification({
          title: data.notification.title,
          message: data.notification.body,
          url: data.data?.url || '/',
          severity: data.data?.severity || 'info'
        });
      } else if (typeof data === 'string') {
        // Intentar parse si es un string
        try {
          const parsedData = JSON.parse(data);
          setNotification({
            title: parsedData.title || 'Nueva notificación',
            message: parsedData.body || parsedData.message || '',
            url: parsedData.url || parsedData.data?.url || '/',
            severity: parsedData.severity || parsedData.data?.severity || 'info'
          });
        } catch (e) {
          // Si no es JSON, mostrar como texto simple
          setNotification({
            title: 'Nueva notificación',
            message: data,
            url: '/',
            severity: 'info'
          });
        }
      }
    };
    
    // Configurar la comunicación bidireccional con el service worker
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.addEventListener('message', handlePushMessage);
      
      // Informar al service worker que la app está lista para recibir notificaciones
      navigator.serviceWorker.controller.postMessage({
        type: 'APP_READY'
      });
    }
    
    // Esperar a que el service worker se active
    navigator.serviceWorker.ready.then(() => {
      console.log('Service Worker listo para recibir notificaciones');
    });
    
    return () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.removeEventListener('message', handlePushMessage);
      }
    };
  }, []);
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setNotification(null);
  };
  
  const handleView = () => {
    if (notification?.url) {
      navigate(notification.url);
    }
    setNotification(null);
  };
  
  if (!notification) return null;
  
  return (
    <Snackbar
      open={!!notification}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={handleClose} 
        severity={notification.severity || 'info'}
        sx={{ width: '100%' }}
        action={
          notification.url && (
            <Button color="inherit" size="small" onClick={handleView}>
              Ver
            </Button>
          )
        }
      >
        <strong>{notification.title}</strong><br />
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

export default InAppNotification;